<template>
  <a-layout>

     <a-layout-header style="background: #fff; padding: 0">
      <span class="header-title">
        Account
      </span>
    </a-layout-header>

    <a-row type="flex" justify="space-around" align="middle">
      <a-col style="width: 100%;">

        <a-card
          class="pref-card"
          :bordered="false"
          >

          <a-tabs default-active-key="1" :animated="false">
            <a-tab-pane key="1" tab="General">

              <div class="option">
                <p>UID: {{ currentUser.uid }}</p>
                <p>E-Mail: {{ currentUser.email }}</p>
              </div>

            </a-tab-pane>

            <a-tab-pane key="2" tab="Settings" force-render>

              <span>Locale:</span> <a-select
                show-search
                v-model="userLocale"
                class="select"
                style="width: 250px"
                :options="locales"
                option-filter-prop="label"
                :filter-option="filterLocales"
                @change="onLocaleChange"
              >
              </a-select>

              <p>
                <i>WARNING: Changing the locale to a locale with a different first day of the week will shift existing todos!</i>
              </p>
            </a-tab-pane>

          </a-tabs>

        </a-card>

      </a-col>
    </a-row>

  </a-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import firebase from 'firebase/app';
import 'firebase/auth';
import moment from 'moment';
import { localeWeekdayIndicesMonToFri } from '@/utils';
import { localesList } from '../data/locales';

export default {
  name: "UserAccount",
  computed: {
    ...mapGetters({
      userData: 'userdata/getUserdata'
    }),
    currentUser() {
      return firebase.auth().currentUser;
    },
    userLocale: {
      get() {
        return this.userData().locale;
      },
      set(value){
        this.$store.commit(
          'userdata/setUserdataField',
          {key: "locale", value: value}
        );
      }
    }
  },
  data() {
    return {
      locales: localesList,
    }
  },

  methods: {


    filterLocales(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    onLocaleChange(value) {
      moment.locale(value);
      this.$store.commit(
        "userdata/setUserdataField",
        {key: "locale", value: value}
      );
      this.$store.commit(
        "prefs/setPreference",
        {key: "planner.weekdays", value: localeWeekdayIndicesMonToFri()}
      );
      this.$store.dispatch("userdata/saveUserdata")
    },

  }
}
</script>

<style scoped>

.footer {
  margin-top: 25px;
}

.header-title {
  margin-left: 15px;
  color: rgba(0, 0, 0, 0.55);
  display: flex;
  float: left;
  font-size: 1.5em;
}

.option {
  margin-top: 10px;
}

.pref-card {
  margin: 15px;
}

.select {
  margin-left: 10px;
}

</style>

